﻿import { opaccFilterCriterias } from './opacc.class.filter-criterias.factory.js';

export class InputFilter {
  constructor(item, wrapper) {
    this.filterItem = item;
    this.wrapperItem = wrapper;
  }

  searchValue(elem) {
    this.wrapperItem.addEventListener('keyup', e => {
      if (e.keyCode === 13) { //on Enter-Key
        let selectedItem = e.target;
        opaccFilterCriterias.change(selectedItem.dataset.opFilterattr, selectedItem.value, true, this.filterItem);
      }
    });
    
    $(this.wrapperItem).unbind('keyup');
  }
}